import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { RegisterPage } from '@/pages/register/register-page';
import { safeAuthReturn } from '@/shared/lib/auth-return';

/** `?ref=<token>` → optional signup-referral token.  The page reads it from
 *  the URL and includes it in the signup payload so the inviter and the
 *  new user land in each other's contact lists immediately. */
const registerSearch = z.object({
  ref: z.string().min(8).max(128).optional(),
  next: z.unknown().transform((value) => safeAuthReturn(value)).optional(),
  email: z.string().email().max(320).optional().catch(undefined),
});

export const Route = createFileRoute('/register')({
  validateSearch: registerSearch,
  component: RegisterPage,
});
